import { Button, Col, DatePicker, Input, Row, Select, Space } from "antd";
import dayjs from 'dayjs';
import { FC } from "react";
import { useSelector } from "react-redux";
import { checkPermission } from "utils/utils";
import { SearchSvg } from "utils/svgs";
import styles from "./index.module.scss";
import { SearchAndFilterProps } from "./types";
const { RangePicker } = DatePicker;

// For search filter and paginate
const SearchAndFilter: FC<SearchAndFilterProps> = (props) => {
  // Init
  const {
    performSearchHandler,
    searchValue,
    title,
    setSearch,
    allUsers,
    setSelectedUser,
    selectedUser,
    selectedDate,
    setSelectedDate,
    totalRecords
  } = props;

  const userPermissions = useSelector(
    (state: any) => state?.userProfile?.data
  );

  const isRejectedViewAll = checkPermission(userPermissions?.permissions, {
    permissionName: 'GroceryRejected',
    permission: ['viewAll'],
  });
  const canViewAllUsers = userPermissions?.isAdmin || isRejectedViewAll;

  // JSX
  return (
    <div className={styles["search-filter"]}>
      <div className={styles["search-filter__wrapper"]}>
        <Row justify={"space-between"}>
          <Col>
            <div className={styles["search-filter__wrapper--title"]}>
              {title}
              <span className={styles["search-filter__wrapper--title--count"]}>({totalRecords})</span>
            </div>
          </Col>
          <Col>
            <Space>
              <Button
                onClick={() => {
                  setSearch('');
                  if (canViewAllUsers) {
                    setSelectedUser(undefined);
                  }
                  setSelectedDate(null);
                }}
              >
                Clear all
              </Button>


              <Input
                className={styles["search-filter__search"]}
                placeholder="Search by Product Name"
                prefix={<SearchSvg />}
                onChange={performSearchHandler}
                value={searchValue}
                size="large"
                allowClear
              />

              {canViewAllUsers && (
                <Select
                  showSearch
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    (option?.label ?? '')
                      .toString()
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  value={selectedUser}
                  placeholder="Select User"
                  size="large"
                  style={{ width: 200 }}
                  onChange={(value) => setSelectedUser(value)}
                  allowClear
                  options={(allUsers || []).map((item: any) => ({
                    label: item?.name,
                    value: item?.userId,
                  }))}
                />
              )}

              <RangePicker
                picker="date"
                format="DD/MM/YYYY"
                style={{ width: 120, height: 40 }}
                allowClear
                onChange={(value) => {
                  if (!value || !value[0] || !value[1]) {
                    setSelectedDate(null);
                  } else {
                    setSelectedDate([
                      dayjs(value[0]).startOf("day"),
                      dayjs(value[1]).endOf("day")
                    ]);
                  }
                }}
                value={selectedDate}
              />


              {/* {
                userPermissions?.roleName === 'Admin' &&
                <div className={`${styles['file-upload-container']} file-upload-container`}>
                  <Upload {...uploadProps}>
                    <Button icon={<UploadOutlined />} style={{ width: "50px", height: "39px" }} />
                  </Upload>
                </div>
              } */}

              {/* <div className={styles['user-table__action']}>
                {(isAddPermission) && (
                  <button
                    className={`btn-blue ${styles['user-table__action--button']}`}
                    onClick={openDrawerHandler}
                  >
                    <AddSvg />
                    <p>Add Medicines</p>
                  </button>
                )}
              </div> */}
            </Space>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SearchAndFilter;

